module.exports = __webpack_public_path__ + "static/img/product3.d64db1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/black/product3.png
// module id = fd17
// module chunks = 0